import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const resultsApi = {
  /**
   * List agent analysis rows with optional day filter (moderator-auth).
   * @param {{
   *   date?: string;
   *   start_time?: string;
   *   time_field?: 'scraped_at' | 'published_at';
   *   skip?: number;
   *   limit?: number;
   * }} [params]
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  list: (params = {}, config = {}) =>
    mod.get('/results/', { ...config, params: { limit: 1000, ...params } }),
};
